// Doc-sharing vocabulary and access rules, one place for the modal, the
// pending banner, the shared badge and the pages that gate actions (TT-807).

// Mirrors PERM_READ/WRITE/ADMIN in platform domain/serv/acl.py
export const PERM_VIEW = 10;
export const PERM_EDIT = 20;
export const PERM_FULL = 30;

// What the owner can grant from the share modal. Full access (admin) is not
// offered: at the API it lets a recipient share onward, and those grants are
// invisible to the owner's access list, while tapp shows a recipient none of
// the owner's controls. Grants made earlier still read by their label.
export const PERMISSIONS = [
  { value: PERM_VIEW, label: "Can view", description: "Read the document" },
  { value: PERM_EDIT, label: "Can edit", description: "Also rename it and make Tapestries from it" },
];

const LABELS = { [PERM_VIEW]: "Can view", [PERM_EDIT]: "Can edit", [PERM_FULL]: "Full access" };

export const permLabel = (p) => LABELS[p] || "Shared";

// What appback enforces (domain/views/users.py): renaming a doc (which lands
// on the owner's doc row) and deleting someone else's tapestry on it take
// write; owners hold admin.
export const canEditDoc = (doc) => !doc?.shared || (doc.permission || 0) >= PERM_EDIT;

export const sharedByLabel = (doc) => `${doc?.sharedByName || "Someone"} · ${permLabel(doc?.permission)}`;

export const isEmailLike = (value) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
